<template>
    <div class="share-box">

        <!-- 已领取 -->
        <div v-if="this.partQual" class="form-box">
            <img class="coupon-img" src="https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/aPennyRide/digitalCurrencyForICBC/activity/icon_apenny_icbc_coupon.png"/>
            <div class="coupon-query">
                <div class="coupon-has">{{ toast }}</div>
                <div class="query-num" @click="handleQueryNum">查询权益次数</div>
            </div>
        </div>

        <div v-else>
            <!-- 不可领取状态 -->
          <div v-if="this.showCopywriting" class="form-box">
              <img class="writing-img" src="https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/aPennyRide/digitalCurrencyForICBC/activity/icon_apenny_icbc_writing.png"/>
          </div>
          <!-- 手机号 验证码 领取按钮 未领取情况 -->
          <div v-else class="form-box">
              <div class="form-item" style="margin-top: 20px;">
                  <div class="form-label">手机号</div>
                  <div class="form-line"></div>
                  <input name="phone" type="text" maxlength="11" class="form-input" placeholder="请输入您的手机号" v-model="phone">
              </div>
              <div class="form-authcode">
                  <div class="suthcode-left">
                      <div class="form-label">验证码</div>
                      <div class="form-line"></div>
                      <input name="authcode" type="text" maxlength="6" class="form-input" placeholder="请输入验证码"
                          v-model="authcode" style="width: 90px;">
                  </div>
                  <button class="form-code-btn" :class="{ 'form-code-btn-disable': disabled }" :disabled="disabled" @click="sendCode">{{ btntxt }}</button>
              </div>
              <div class="btn-box">
                  <img class="btn-img" @click="handleGetBtnClick" src="https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/aPennyRide/digitalCurrencyForICBC/activity/icon_apenny_icbc_getbtn.png"/>
              </div>

              <div class="agree-box">
                  <img v-if="isAgree" class="agree-img" @click="handleAgreeClick" src="https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/aPennyRide/digitalCurrencyForICBC/activity/yixuanzhong%402x.png"/>
                  <img v-else class="agree-img" @click="handleAgreeClick" src="https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/aPennyRide/digitalCurrencyForICBC/activity/weixuanzhong%402x.png"/>
                  <div class="agree-text">我已知悉活动规则并同意参与活动</div>
              </div>
          </div>
        </div>
        <!-- 活动规则 -->
        <div class="rule-box">
            <img class="rule-img" src="https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/aPennyRide/digitalCurrencyForICBC/activity/icon_apenny_icbc_rule_bjqd.png" />
        </div>
        <!-- 活动细则 -->
        <div class="rule-box" style="margin-top: 5px;">
            <img class="rule-img"
                src="https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/aPennyRide/digitalCurrencyForICBC/activity/icon_apenny_icbc_detail.png" />
        </div>
        <!-- 温馨提示 -->
        <div class="tip-box">
            <div class="qa" @click="handleQAClick"></div>
        </div>
        <!-- 咨询电话 -->
        <div class="rule-box" style="margin-top: 10px;">
            <img class="rule-img"
                src="https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/aPennyRide/digitalCurrencyForICBC/activity/icon_apenny_icbc_phone.png" />
        </div>
        <!-- logo -->
        <div class="rule-box" style="margin-top: 5px; margin-bottom: 30px;">
            <img class="rule-img"
                src="https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/aPennyRide/digitalCurrencyForICBC/activity/icon_apenny_icbc_logo.png" />
        </div>
    </div>
</template>

<script>

import { setStore, removeStore, getStore } from '@/utils/index'
import { Toast } from 'vant'
import { apiSendCode } from '@/api'
import { getRegister } from '@/api/khCoupon'
import { partActivity, queryUserConsumeActivityPartQual } from '@/api/active'

export default {
  name: 'offsitSharePage',
  components: {
  },
  data () {
    return {
      token: '',
      disabled: false,
      time: 0,
      btntxt: '获取验证码',
      phone: '', // 修改的手机号
      authcode: '',
      canSubmit: true,
      timerOut: null,
      isAgree: true,
      activityNo: '', // 活动编号 有活动时返回 无活动时返回空
      showCopywriting: false, // 是否显示提醒
      partQual: false, // 当前用户是否有资格参与 true 有资格 false 无资格
      partTimes: 0, // 当前用户剩余可参与次数
      toast: '乘车权益包领取成功！' // 领取成功 or 已领取文案
    }
  },
  mounted () {
    this.token = getStore('token')
    if (this.token) {
      setStore('token', this.token)
      this.queryActivityPartQual()
    }
  },
  destroyed () {
    removeStore('token')
  },
  methods: {
    // 查询权益次数
    handleQueryNum () {
      this.$router.push({ path: '/icbcCouponNum', query: { accessToken: this.token, fromBjqd: '0' } })
    },

    handleAgreeClick () {
      this.isAgree = !this.isAgree
    },

    // 常见问题
    handleQAClick () {
      this.$router.push({ path: '/icbcQA', query: { accessToken: this.token } })
    },

    // 乘车码优惠活动资格查询
    queryActivityPartQual () {
      const requestData = {
      }
      queryUserConsumeActivityPartQual(requestData).then(res => {
        const data = res.data
        if (data.code === 200) {
          const datas = res.data.result
          this.activityNo = datas.activityNo
          this.partQual = datas.partQual
          this.partTimes = datas.partTimes
          this.showCopywriting = datas.showCopywriting
          if (this.partQual) {
            this.toast = '您已领取乘车权益包！'
          }
        }
      })
    },

    // 乘车码优惠活动资格查询并领取请求
    queryActivityPartQual2 () {
      const requestData = {
      }
      queryUserConsumeActivityPartQual(requestData).then(res => {
        const data = res.data
        if (data.code === 200) {
          const datas = res.data.result
          this.activityNo = datas.activityNo
          this.showCopywriting = datas.showCopywriting
          const partQual = datas.partQual
          if (!this.activityNo) {
            this.canSubmit = true
            Toast({
              message: '暂无活动'
            })
            return
          }
          if (partQual) {
            this.partQual = datas.partQual
            this.partTimes = datas.partTimes
            this.canSubmit = true
            this.toast = '您已领取乘车权益包！'
            Toast({
              message: '您已领取乘车权益包！'
            })
          } else {
            if (this.showCopywriting) {
              return
            }
            this.requestPartActivity()
          }
        } else {
          this.canSubmit = true
        }
      })
    },

    // 领取按钮点击
    handleGetBtnClick () {
      if (!this.phone) {
        Toast({
          message: '手机号不能为空'
        })
        return
      }
      if (!this.checkPhone(this.phone)) {
        Toast({
          message: '手机号格式不正确'
        })
        return
      }
      if (!this.authcode) {
        Toast({
          message: '验证码不能为空'
        })
        return
      }
      if (!this.isAgree) {
        Toast({
          message: '请先知悉活动规则并同意参与活动'
        })
        return
      }
      if (!this.canSubmit) {
        return
      }
      this.canSubmit = false
      this.requestRegistr()
    },

    // 领取权益请求
    requestPartActivity () {
      const queryList = {
      }
      partActivity(queryList).then(res => {
        const data = res.data
        this.canSubmit = true
        if (data.code === 200) {
          const datas = res.data.result
          this.activityNo = datas.activityNo
          this.partQual = datas.partQual
          this.partTimes = datas.partTimes
          if (this.partQual) {
            this.toast = '乘车权益包领取成功！'
            Toast({
              message: '乘车权益包领取成功！'
            })
          } else {
            Toast({
              message: '乘车权益包领取失败！'
            })
          }
        }
      })
    },

    // 注册登录便捷青岛 获取token
    requestRegistr () {
      const that = this
      let data = {
        account: this.phone,
        authCode: this.authcode,
        loginType: 2,
        clientId: 'bjqd-icbc'
      }
      getRegister(data).then((res) => {
        if (res.data.code !== 200) {
          this.canSubmit = true
          Toast({
            message: res.data.message
          })
        } else if (res.data.code === 200) {
          removeStore('token')
          const token = res.data.result.accessToken
          this.token = token
          setStore('token', token)
          that.queryActivityPartQual2()
          this.disabled = true
          this.clearTimer()
        }
      })
    },

    timer () {
      if (this.time > 0) {
        this.time--
        this.btntxt = this.time + 's后再获取'
        this.timerOut = setTimeout(this.timer, 1000)
      } else {
        this.time = 0
        this.btntxt = '重新发送'
        this.disabled = false
      }
    },
    clearTimer () {
      clearTimeout(this.timerOut)
    },
    destroyed () {
      this.clearTimer()
    },
    sendCode (e) {
      e.preventDefault()
      if (!this.phone) {
        Toast({
          message: '手机号不能为空'
        })
        return
      } else if (!this.checkPhone(this.phone)) {
        Toast({
          message: '手机号格式不正确'
        })
        return
      } else {
        this.time = 60
        this.disabled = true
        this.timer()
      }
      let data = {
        clientId: 'bjqd-icbc',
        type: 3,
        phone: this.phone
      }
      apiSendCode(data).then((res) => {
        if (res.data.code !== 200) {
          Toast({
            message: res.data.message,
            duration: 1500
          })
        }
      })
    },
    checkPhone (phone) {
      let reg = /^1[3456789]\d{9}$/
      if (reg.test(phone)) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.share-box {
    position: relative;
    min-height: 100vh;
    height: 100%;
    background: #B1D363 url('https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/aPennyRide/digitalCurrencyForICBC/activity/icon_apenny_icbc_bg.png') no-repeat;
    background-size: 100%;
    overflow-x: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.form-box {
    margin-top: (606vw / 7.5);
    width: (700vw / 7.5);
    border-radius: 15px;
    background: #ffffffff;
    margin-bottom: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .coupon-img {
        margin-top: 25px;
        width: (412vw / 7.5);
    }

    .writing-img {
      margin-top: 20px;
      margin-bottom: 20px;
      width: (700vw / 7.5);
    }

    .coupon-query {
        margin-top: 15px;
        margin-bottom: 20px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        .coupon-has {
            font-size: 16px;
            color: #494949;
            font-weight: 400;
            line-height: 20px;
        }
        .query-num {
            margin-left: 12px;
            font-size: 16px;
            color: #FE4C30;
            font-weight: 400;
            line-height: 20px;
            text-decoration: underline;
        }
    }

    .ride-btn {
        margin-bottom: 20px;
        width: (600vw / 7.5);
    }

    .form-item {
        width: (600vw / 7.5);
        height: 40px;
        border-radius: 8px;
        background: #f5f5f5;
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .form-authcode {
        margin-top: 14px;
        width: (600vw / 7.5);
        height: 40px;
        border-radius: 8px;
        background: #f5f5f5;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        .suthcode-left {
            flex: 1;
            display: flex;
            flex-direction: row;
            align-items: center;
        }
    }

    .form-code-btn {
        padding-right: 10px;
        white-space: nowrap;
        font-size: (28vw / 7.5);
        color: #EE4332;
        background: none;
        line-height: 1;
        outline: none;
        font-weight: 400;
        text-decoration: underline;
    }
    .form-code-btn-disable {
        padding-right: 10px;
        white-space: nowrap;
        font-size: (28vw / 7.5);
        color: #949494;
        background: none;
        line-height: 1;
        outline: none;
        font-weight: 400;
        text-decoration: none;
    }

    .form-label {
        width: (100vw / 7.5);
        margin-left: (28vw / 7.5);
        font-size: (30vw / 7.5);
        color: #474747;
        font-weight: 400;
    }

    .form-line {
        margin-left: (30vw / 7.5);
        margin-right: (30vw / 7.5);
        width: 0.5px;
        height: 17px;
        background: #c3c3c3;
    }

    .form-input {
        font-size: (28vw / 7.5);
        color: #282828;
        font-weight: 400;
        line-height: 40px;
        background: none;
    }
    .btn-box {
        margin-top: 13px;
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        .btn-img {
            width: (600vw / 7.5);
        }
    }
    .agree-box {
        margin: 20px;
        width: (600vw / 7.5);
        display: flex;
        flex-direction: row;
        align-items: center;
        .agree-img {
            height: 18px;
            width: 18px;
            margin-right: 13px;
        }
        .agree-text {
            font-size: 13px;
            color: #5C5C5C 100%;
            font-weight: 400;
        }
    }
}

.rule-box {
    width: (700vw / 7.5);
}

.rule-img {
    width: (700vw / 7.5);
}

.tip-box {
    margin-top: 5px;
    width: (700vw / 7.5);
    height: (542vw / 7.5);
    background: url('https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/aPennyRide/digitalCurrencyForICBC/activity/icon_apenny_icbc_tip.png') no-repeat;
    background-size: 100%;
    overflow-x: hidden;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;

    .qa {
        height: (80vw / 7.5);
        width: (300vw / 7.5);
        margin-bottom: 10px;
    }
}</style>
